<template>
	<div>
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>
		<Row class-name="padding-tb-sm" :gutter="16">
			<Col span="16">
			<div class="bg-white padding-xl">
				<div class="flex justify-between">
					<div class="text-lg flex" style="line-height:40px;">
						<div style="width:100px;" class="text-right">
							<span class="text-grey">申请单号：</span>
						</div>
						<div class="padding-left">
							<span class="text-bold text-black text-xxl">{{orderid}}</span>
						</div>
					</div>
					<div class="">
						<Button type="warning" size="large" @click="modalModifyShow()" icon="ios-create-outline">处理</Button>
					</div>
				</div>
				<Divider />
				<Row class-name="padding-tb-sm">
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">会员信息：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left flex">
							<div class=" padding-top-xs">
								<Avatar :src="'http://cjb.xahulian.com/'+ info.user.avatar " size="48" v-if="info.user.avatar" />
								<Avatar icon="ios-person" size="48" v-else />
							</div>
							<div class="padding-left-sm padding-top-xs text-left">
								<span class="text-lg">{{info.user.nickname}}</span><br />
								<span class="text-blue">{{info.user.mobile}}</span>
							</div>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">订单状态：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<Tag color="warning" v-if="info.stateflag=='0'">未处理</Tag>
							<Tag color="primary" v-if="info.stateflag=='1'">处理中</Tag> 
							<Tag color="success" v-if="info.stateflag=='6'">已处理</Tag> 
							<Tag v-if="info.stateflag=='9'">已取消</Tag> 
						</div>
						</Col>
					</Row>
					</Col>
				</Row>
				<Row class-name="padding-tb-sm">
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">提现积分：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-red">{{info.score}}</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">手续费：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-red">{{info.sxf}}%</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">支付金额：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-red">{{(info.score-info.score*info.sxf/100)/100}}元</span>
						</div>
						</Col>
					</Row>
					</Col>
				</Row>
				<Row class-name="padding-tb-sm">
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">下单时间：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{info.addtime}}</span>
						</div>
						</Col>
					</Row>
					</Col>
					<Col span="8">
					<Row>
						<Col span="6">
						<div class="text-right">
							<span class="text-grey">更新时间：</span>
						</div>
						</Col>
						<Col span="18">
						<div class="text-left padding-left">
							<span class="text-bold text-black">{{info.updatetime}}</span>
						</div>
						</Col>
					</Row>
					</Col>
				</Row>
				<Row class-name="padding-tb-sm">
					<Col span="2">
					<div class="text-right">
						<span class="text-grey">订单备注：</span>
					</div>
					</Col>
					<Col span="22">
					<div class="text-left padding-left">
						<span class="text-bold text-black">{{info.remark}}</span>
					</div>
					</Col>
				</Row>
			</div>
			</Col>
			<Col span="8">
			<div class="bg-white padding-xl">
				<div class="padding-top-sm padding-bottom-xs text-xxl text-bold">处理记录</div>
				<Divider />
				<div style="position: relative;">
					<Timeline v-if="info.reply">
						<TimelineItem v-for="item in info.reply" :key="index">
							<p class="time text-bold text-blue">{{item.time}}</p>
							<p class="content">{{item.content}}</p>
						</TimelineItem>
					</Timeline>
					<Spin fix v-if="loading">
						<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
						<div>加载中...</div>
					</Spin>
				</div>
			</div>
			</Col>
		</Row>

		<Modal v-model="modalReplyShow" title="处理申请" :footer-hide="true" :width="520">
			<div style="position: relative;" class="padding-right-xl">
				<Form ref="formReply" :model="formReply" label-position="right" :label-width="100" label-colon>
					<FormItem label="处理结果">
						<RadioGroup v-model="formReply.state">
							<Radio label="1" border>处理中</Radio>
							<Radio label="6" border>确认支付</Radio>
							<Radio label="9" border>取消</Radio>
						</RadioGroup>
					</FormItem>
					<FormItem label="回执">
						<Input v-model="formReply.content" type="textarea" :rows="5" show-word-limit :maxlength="140" placeholder="回执内容"></Input>
					</FormItem>
					<Divider />
					<FormItem>
						<Button type="primary" @click="submitReply('formReply')" :loading="loadingReply" icon="ios-add">提交</Button>
						<Button style="margin-left: 8px" @click="modalReplyShow=false">取消</Button>
					</FormItem>
				</Form>
					<Spin fix v-if="loadingReply">
						<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
						<div>加载中...</div>
					</Spin>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				orderid: '',
				info: {
					user: {},
					reply: {}
				},
				loading: false,
				modalReplyShow: false,
				loadingReply: false,
				formReply: {
					orderid: '',
					state: "1",
					content: ''
				}
			};
		},
		methods: {
			loadinfo() {
				let postData = {
					orderid: this.orderid
				};
				this.$http.post('/server/api/client/tx/view.php?a=init', this.$qs.stringify(postData)).then(
					res => {
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.info = res.data.data;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.$Message.error('系统错误');
					}
				);
			},
			modalModifyShow() {
				this.formReply.orderid = this.orderid;
				this.modalReplyShow = true;
			},
			submitReply(name) {
				this.loadingReply = true;
				this.$http.post('/server/api/client/tx/view.php?a=deal', this.$qs.stringify(this.formReply)).then(
					res => {
						this.loadingReply = false;
						if (res.data.result == 'ok') {
							this.$Message.success('操作成功!');
							this.loadinfo();
							this.modalReplyShow = false;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loadingReply = false;
						this.$Message.error('系统错误');
					}
				);
			}
		},
		created() {
			//console.log(this.searchForm)
			this.orderid = this.$route.params.id;
			this.loadinfo();
		}
	};
</script>

<style>
	img {
		display: block;
	}

	.imgbox {
		border: #ddd 1px solid;
		box-shadow: #aaa 0 0 8px;
	}

	.demo-spin-icon-load {
		animation: ani-demo-spin 1s linear infinite;
	}
</style>
